import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center border whitespace-nowrap transition-colors focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        success:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-success text-success-foreground hover:bg-success/80",
        info:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-info text-info-foreground hover:bg-info/80",
        warning:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        outline: "text-label-sm rounded-sm px-xs py-xs text-foreground",
        ghost:
          "text-label-sm rounded-sm px-xs py-xs border-transparent bg-transparent text-muted-foreground hover:bg-accent hover:text-accent-foreground",
        time:
          "border-transparent bg-primary text-primary-foreground rounded-lg p-sm gap-xs text-value-sm",
        "time-outline":
          "border-primary bg-transparent text-primary rounded-lg p-sm gap-xs text-value-sm",
      },
      roundness: {
        default: "",
        round: "rounded-full px-2 py-1",
      },
    },
    defaultVariants: {
      variant: "default",
      roundness: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, roundness, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, roundness }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
